import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { Notification } from '../../../../config/Global';
const { Title } = Typography;

const DeleteRoomCategoryComponent = observer((props) => {
	const { visible, onClose, propertyId } = props;
	const [saving, setSaving] = useState();
	const { ACCOMMODATION } = useStore();
	const { propertyDetail, roomCategoryDetail } = ACCOMMODATION;

	const deleteChangeRoomCategory = () => {
		setSaving(true);
		let roomCategoryPayload = {
			id: visible.id,
			versionNo: visible.versionNo,
		};
		ACCOMMODATION.deleteRoomCategory({
			...roomCategoryPayload,
		})
			.then((msg) => {
				Notification.success({
					message: Message().CRUD.DELETE('Room Category'),
				});
				ACCOMMODATION.getRoomCategoryByProperty(
					props.propertyId.propertyID
				);
				onClose();
			})
			.catch((e) => {
				Notification.error({
					message: 'Something Wrong',
				});
			})
			.finally(() => setSaving(false));
	};

	return (
		<Modal
			title="Delete Room Category"
			onCancel={onClose}
			open={visible}
			destroyOnClose
			width={'450px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						loading={saving}
						onClick={deleteChangeRoomCategory}
					>
						Delete
					</Button>
					<Button key={2} onClick={onClose}>
						Cancel
					</Button>
				</div>
			}
		>
			<Title level={5}>
				Are you sure you want to
				<b> delete {' ' + visible?.roomTitle + ' '}</b>
				roomcategory?
			</Title>
		</Modal>
	);
});

export default DeleteRoomCategoryComponent;
